import { cardChannels } from '../models/channels';
import { CHANNEL_KEYS, CATEGORY_KEYS, CATEGORY_NAMES } from '../constants/keys';

export type ChannelCategoryTheme = {
  id: string;
  name: string;
  icon: React.ReactNode;
  gradientFrom: string;
  gradientTo: string;
  textColor: string;
  badgeBg: string;
  badgeText: string;
  channelIds: string[];
  hidden?: boolean;
};

export const channelCategories = [
  {
    id: CATEGORY_KEYS.ONLINE_SHOPPING,
    name: CATEGORY_NAMES[CATEGORY_KEYS.ONLINE_SHOPPING],
    icon: (
      <svg
        className="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
        />
      </svg>
    ),
    gradientFrom: 'from-purple-50 dark:from-purple-900/20',
    gradientTo: 'to-indigo-50 dark:to-indigo-900/20',
    textColor: 'text-indigo-600 dark:text-indigo-400',
    badgeBg: 'bg-indigo-100 dark:bg-indigo-900/50',
    badgeText: 'text-indigo-800 dark:text-indigo-300',
    channelIds: [
      CHANNEL_KEYS.ONLINE_SHOPPING,
      CHANNEL_KEYS.SHOPEE,
      CHANNEL_KEYS.MOMO,
      CHANNEL_KEYS.PCHOME,
      CHANNEL_KEYS.COUPANG,
    ],
    hidden: false,
  },
  {
    id: CATEGORY_KEYS.TRAVEL,
    name: CATEGORY_NAMES[CATEGORY_KEYS.TRAVEL],
    icon: (
      <svg
        className="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
    gradientFrom: 'from-blue-50 dark:from-blue-900/20',
    gradientTo: 'to-cyan-50 dark:to-cyan-900/20',
    textColor: 'text-blue-600 dark:text-blue-400',
    badgeBg: 'bg-blue-100 dark:bg-blue-900/50',
    badgeText: 'text-blue-800 dark:text-blue-300',
    channelIds: [
      CHANNEL_KEYS.TRAVEL,
      CHANNEL_KEYS.AIRPORT_LOUNGE,
      CHANNEL_KEYS.BUSINESS,
      CHANNEL_KEYS.KKDAY,
      CHANNEL_KEYS.KLOOK,
      CHANNEL_KEYS.AGODA,
      CHANNEL_KEYS.BOOKING,
      CHANNEL_KEYS.MILEAGE,
      CHANNEL_KEYS.HOTEL,
    ],
    hidden: false,
  },
  {
    id: CATEGORY_KEYS.DINING,
    name: CATEGORY_NAMES[CATEGORY_KEYS.DINING],
    icon: (
      <svg
        className="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
    gradientFrom: 'from-amber-50 dark:from-amber-900/20',
    gradientTo: 'to-orange-50 dark:to-orange-900/20',
    textColor: 'text-amber-600 dark:text-amber-400',
    badgeBg: 'bg-amber-100 dark:bg-amber-900/50',
    badgeText: 'text-amber-800 dark:text-amber-300',
    channelIds: [
      CHANNEL_KEYS.DINING,
      CHANNEL_KEYS.FOOD_DELIVERY,
      CHANNEL_KEYS.RESTAURANT,
      CHANNEL_KEYS.CAFE,
    ],
    hidden: false,
  },
  {
    id: CATEGORY_KEYS.TRANSPORTATION,
    name: CATEGORY_NAMES[CATEGORY_KEYS.TRANSPORTATION],
    icon: (
      <svg
        className="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
        />
      </svg>
    ),
    gradientFrom: 'from-green-50 dark:from-green-900/20',
    gradientTo: 'to-teal-50 dark:to-teal-900/20',
    textColor: 'text-green-600 dark:text-green-400',
    badgeBg: 'bg-green-100 dark:bg-green-900/50',
    badgeText: 'text-green-800 dark:text-green-300',
    channelIds: [
      CHANNEL_KEYS.TRANSPORTATION,
      CHANNEL_KEYS.GAS_STATION,
      CHANNEL_KEYS.SHARED_SCOOTER,
      CHANNEL_KEYS.TAIWAN_HIGH_SPEED_RAILWAY,
    ],
    hidden: false,
  },
  {
    id: CATEGORY_KEYS.MOBILE_PAYMENT,
    name: CATEGORY_NAMES[CATEGORY_KEYS.MOBILE_PAYMENT],
    icon: (
      <svg
        className="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
        />
      </svg>
    ),
    gradientFrom: 'from-violet-50 dark:from-violet-900/20',
    gradientTo: 'to-purple-50 dark:to-purple-900/20',
    textColor: 'text-violet-600 dark:text-violet-400',
    badgeBg: 'bg-violet-100 dark:bg-violet-900/50',
    badgeText: 'text-violet-800 dark:text-violet-300',
    channelIds: [
      CHANNEL_KEYS.MOBILE_PAYMENT,
      CHANNEL_KEYS.LINE_PAY,
      CHANNEL_KEYS.APPLE_PAY,
      CHANNEL_KEYS.JKOPAY,
      CHANNEL_KEYS.PXPAYPLUS,
      CHANNEL_KEYS.DIGITAL_BANKING,
    ],
    hidden: false,
  },
  {
    id: CATEGORY_KEYS.OVERSEAS,
    name: CATEGORY_NAMES[CATEGORY_KEYS.OVERSEAS],
    icon: (
      <svg
        className="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
        />
      </svg>
    ),
    gradientFrom: 'from-rose-50 dark:from-rose-900/20',
    gradientTo: 'to-red-50 dark:to-red-900/20',
    textColor: 'text-rose-600 dark:text-rose-400',
    badgeBg: 'bg-rose-100 dark:bg-rose-900/50',
    badgeText: 'text-rose-800 dark:text-rose-300',
    channelIds: [
      CHANNEL_KEYS.OVERSEAS,
      CHANNEL_KEYS.JAPAN,
      CHANNEL_KEYS.KOREA,
      CHANNEL_KEYS.SOUTHEAST_ASIA,
      CHANNEL_KEYS.THAILAND,
    ],
    hidden: false,
  },
  {
    id: CATEGORY_KEYS.ENTERTAINMENT,
    name: CATEGORY_NAMES[CATEGORY_KEYS.ENTERTAINMENT],
    icon: (
      <svg
        className="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
    gradientFrom: 'from-pink-50 dark:from-pink-900/20',
    gradientTo: 'to-purple-50 dark:to-purple-900/20',
    textColor: 'text-pink-600 dark:text-pink-400',
    badgeBg: 'bg-pink-100 dark:bg-pink-900/50',
    badgeText: 'text-pink-800 dark:text-pink-300',
    channelIds: [CHANNEL_KEYS.ENTERTAINMENT, CHANNEL_KEYS.STREAMING],
    hidden: false,
  },
  {
    id: CATEGORY_KEYS.DAILY_LIFE,
    name: CATEGORY_NAMES[CATEGORY_KEYS.DAILY_LIFE],
    icon: (
      <svg
        className="w-6 h-6 mr-2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
        />
      </svg>
    ),
    gradientFrom: 'from-yellow-50 dark:from-yellow-900/20',
    gradientTo: 'to-amber-50 dark:to-amber-900/20',
    textColor: 'text-yellow-600 dark:text-yellow-400',
    badgeBg: 'bg-yellow-100 dark:bg-yellow-900/50',
    badgeText: 'text-yellow-800 dark:text-yellow-300',
    channelIds: [
      CHANNEL_KEYS.DAILY_LIFE,
      CHANNEL_KEYS.CONVENIENCE_STORE,
      CHANNEL_KEYS.DEPARTMENT_STORE,
      CHANNEL_KEYS.SUPERMARKET,
      CHANNEL_KEYS.TAX,
      CHANNEL_KEYS.INSURANCE,
    ],
    hidden: false,
  },
] as ChannelCategoryTheme[];

export function getChannelsByCategory(categoryId: string) {
  const category = channelCategories.find(cat => cat.id === categoryId);
  if (!category) return [];

  return cardChannels.filter(channel => category.channelIds.includes(channel.id));
}
